// product-form.js — add to cart (full form + quick-add), variant picker, sticky ATC

// Fly a clone of the product image into the cart icon (Bucks-style).
function flyToCart(btn) {
  try {
    const g = window.gsap;
    const REDUCE = !document.documentElement.classList.contains('force-motion')
      && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!g || REDUCE) return;
    const cartIcon = document.querySelector('[data-cart-open]');
    const card = btn && btn.closest('.product-card');
    const img = (card && card.querySelector('img'))
      || document.querySelector('[data-product-root] img, .product__media img, .product-card img');
    if (!cartIcon || !img) return;
    const r1 = img.getBoundingClientRect();
    const r2 = cartIcon.getBoundingClientRect();
    if (!r1.width) return;
    const clone = img.cloneNode(true);
    clone.removeAttribute('loading');
    Object.assign(clone.style, {
      position: 'fixed', left: r1.left + 'px', top: r1.top + 'px',
      width: r1.width + 'px', height: r1.height + 'px', objectFit: 'cover',
      borderRadius: '14px', zIndex: '100001', pointerEvents: 'none', margin: '0',
      boxShadow: '0 18px 40px rgba(0,0,0,.25)'
    });
    document.body.appendChild(clone);
    g.timeline({ onComplete: () => clone.remove() }).to(clone, {
      duration: 0.85, ease: 'power2.in',
      left: r2.left + r2.width / 2 - 22, top: r2.top + r2.height / 2 - 22,
      width: 44, height: 44, rotation: 28, opacity: 0.35
    });
    g.fromTo(cartIcon, { scale: 1 }, { scale: 1.18, duration: 0.18, yoyo: true, repeat: 1, delay: 0.78 });
  } catch (e) { /* never block add-to-cart on an animation error */ }
}

// Where to write the button's text. Prefer an explicit [data-atc-label] (used
// when the button also contains a price span). Otherwise the visible label is
// the LAST <span> (invert buttons put the bordered bg layer first, label second;
// single-span buttons return their only span).
function labelEl(btn) {
  const explicit = btn.querySelector('[data-atc-label]');
  if (explicit) return explicit;
  const spans = btn.querySelectorAll('span');
  return spans.length ? spans[spans.length - 1] : btn;
}

// Brief "Added ✓" confirmation on the button.
function flashAdded(btn) {
  if (!btn) return;
  const span = labelEl(btn);
  if (btn.__origLabel === undefined) btn.__origLabel = span.textContent;
  span.textContent = 'Added ✓';
  clearTimeout(btn.__addedTimer);
  btn.__addedTimer = setTimeout(() => { span.textContent = btn.__origLabel; }, 1300);
}

const FLY_MS = 850; // keep in sync with flyToCart timeline duration
async function addToCart(items, btn, opts) {
  btn?.setAttribute('aria-busy', 'true');
  const t0 = performance.now();
  if (!(opts && opts.redirect)) flyToCart(btn); // skip the fly animation when leaving the page
  try {
    const r = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer,header' })
    });
    const data = await r.json();
    if (data.status) { console.warn('Add to cart failed', data); return; }
    // Buy now: go straight to checkout instead of opening the cart drawer.
    if (opts && opts.redirect) { window.location.href = opts.redirect; return; }
    window.refreshCartSections?.(data.sections);
    flashAdded(btn);
    // Open the cart once the flying image has landed — but never add dead time
    // if the request itself already took longer than the fly animation.
    const wait = Math.max(0, FLY_MS - (performance.now() - t0));
    setTimeout(() => document.dispatchEvent(new CustomEvent('cart:open')), wait);
  } finally { btn?.removeAttribute('aria-busy'); }
}
// Force an explicit selection on the PDP before adding to cart.
function flashSelect(el) {
  try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  el.classList.add('ring-2', 'ring-red', 'ring-offset-2', 'rounded-xl');
  let note = el.querySelector('[data-select-note]');
  if (!note) {
    note = document.createElement('p');
    note.setAttribute('data-select-note', '');
    note.className = 'mt-2 font-sans text-small text-red';
    el.appendChild(note);
  }
  note.textContent = el.hasAttribute('data-colour-pick') ? 'Please pick your colours first.' : 'Please choose an option first.';
  note.style.display = '';
  clearTimeout(el.__selT);
  el.__selT = setTimeout(() => { el.classList.remove('ring-2', 'ring-red', 'ring-offset-2'); }, 1800);
}
// Returns true (and nudges the user) when a required PDP selection is missing.
function pdpGuard() {
  const pick = document.querySelector('[data-colour-pick]');
  if (pick) {
    const hidden = pick.querySelector('[data-pick-input]');
    if (!hidden || !hidden.value.trim()) { flashSelect(pick); return true; }
    return false;
  }
  const vp = document.querySelector('product-form variant-picker[data-has-options="true"]');
  if (vp && vp.dataset.touched !== 'true') { flashSelect(vp); return true; }
  return false;
}
// Quick-add buttons
document.addEventListener('click', (e) => {
  const qa = e.target.closest('[data-quick-add][data-variant-id]');
  if (!qa || qa.disabled) return;
  e.preventDefault();
  if (qa.closest('[data-sticky-atc]') && pdpGuard()) return; // sticky ATC on PDP: force selection
  addToCart([{ id: Number(qa.dataset.variantId), quantity: 1 }], qa);
});

// Product-card option chips: switch the quick-add variant by option-1 value
const CARD_ON = ['bg-forest', 'text-cream', 'border-forest'];
const CARD_OFF = ['border-foreground/30', 'text-foreground/75'];
document.addEventListener('click', (e) => {
  const opt = e.target.closest('[data-card-opt]');
  if (!opt) return;
  const card = opt.closest('[data-card]');
  const json = card && card.querySelector('[data-card-variants]');
  const qa = card && card.querySelector('[data-quick-add]');
  if (!json || !qa) return;
  let variants;
  try { variants = JSON.parse(json.textContent); } catch (_) { return; }
  const matches = variants.filter((v) => v.options[0] === opt.dataset.value);
  const v = matches.find((m) => m.available) || matches[0];
  if (!v) return;
  card.querySelectorAll('[data-card-opt]').forEach((b) => {
    const on = b === opt;
    if (b.hasAttribute('data-swatch')) {
      b.classList.toggle('border-forest', on);
      b.classList.toggle('ring-2', on);
      b.classList.toggle('ring-forest/40', on);
      b.classList.toggle('border-foreground/20', !on);
    } else {
      b.classList.toggle(CARD_ON[0], on); b.classList.toggle(CARD_ON[1], on); b.classList.toggle(CARD_ON[2], on);
      b.classList.toggle(CARD_OFF[0], !on); b.classList.toggle(CARD_OFF[1], !on);
    }
  });
  qa.dataset.variantId = v.id;
  qa.disabled = !v.available;
  const lab = qa.querySelector('[data-qa-label]');
  if (lab) lab.textContent = v.available ? 'Add to cart' : 'Sold out';
  const img = card.querySelector('a img');
  if (img && v.featured_image && v.featured_image.src) img.src = v.featured_image.src;
});
// Full product form
class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      if (pdpGuard()) return; // force variant/colour selection before adding
      if (!this.form.reportValidity()) return; // enforce required fields (e.g. phone model)
      const id = Number(this.form.querySelector('[name="id"]').value);
      const qty = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
      // Collect line-item properties (e.g. Custom colour request).
      const props = {};
      this.form.querySelectorAll('[name^="properties["]').forEach((el) => {
        const m = el.name.match(/^properties\[(.+)\]$/);
        if (m && String(el.value).trim()) props[m[1]] = String(el.value).trim();
      });
      const item = { id, quantity: qty };
      if (Object.keys(props).length) item.properties = props;
      const submitter = e.submitter;
      const buyNow = !!(submitter && submitter.hasAttribute('data-buy-now'));
      addToCart([item], submitter || this.form.querySelector('[type="submit"]'),
        buyNow ? { redirect: window.Shopify.routes.root + 'checkout' } : undefined);
    });
  }
}
customElements.define('product-form', ProductForm);
// Variant picker: update hidden id + price + availability from variant <option>/<input>
class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.addEventListener('change', () => { this.dataset.touched = 'true'; this.update(); });
  }
  update() {
    const chosen = Array.from(this.querySelectorAll('select, input:checked')).map((el) => el.value);
    const match = this.variants.find((v) => chosen.every((opt) => v.options.includes(opt)));
    const root = this.closest('[data-product-root]') || document;
    const idInput = root.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const atc = root.querySelector('[data-atc]');
    if (!match) { if (atc) { atc.disabled = true; labelEl(atc).textContent = 'Unavailable'; } return; }
    if (idInput) idInput.value = match.id;
    const pricesEl = root.querySelector('[data-variant-prices]');
    const pricesMap = pricesEl ? JSON.parse(pricesEl.textContent) : {};
    if (priceEl && pricesMap[match.id]) priceEl.innerHTML = pricesMap[match.id];
    const stickyBtn = document.querySelector('[data-sticky-atc] [data-quick-add]');
    if (stickyBtn) stickyBtn.dataset.variantId = match.id;
    const stickyPrice = document.querySelector('[data-sticky-atc] [data-price]');
    if (stickyPrice && pricesMap[match.id]) stickyPrice.innerHTML = pricesMap[match.id];
    if (atc) { atc.disabled = !match.available; labelEl(atc).textContent = match.available ? 'Add to cart' : 'Sold out'; }
  }
}
customElements.define('variant-picker', VariantPicker);

// Lazy-load product recommendations + reveal sticky ATC after hero scrolls away
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.querySelector('.product-grid')) return;
    fetch(this.dataset.url).then((r) => r.text()).then((html) => {
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
      if (el) {
        this.innerHTML = el.innerHTML;
        this.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach((node) => {
          node.style.transitionDelay = '';
          node.classList.add('is-visible');
        });
      }
    }).catch(() => {});
  }
}
customElements.define('product-recommendations', ProductRecommendations);
const stickyAtc = document.querySelector('[data-sticky-atc]');
const atcBtn = document.querySelector('[data-atc]');
if (stickyAtc && atcBtn) {
  const io = new IntersectionObserver(([e]) => {
    stickyAtc.hidden = e.isIntersecting;
    document.documentElement.classList.toggle('sticky-atc-on', !e.isIntersecting);
  }, { threshold: 0 });
  io.observe(atcBtn);
}
// Quantity steppers
document.addEventListener('click', (e) => {
  const inc = e.target.closest('[data-q-inc]'); const dec = e.target.closest('[data-q-dec]');
  if (!inc && !dec) return;
  const input = (inc || dec).parentElement.querySelector('input[name="quantity"]');
  input.value = Math.max(1, parseInt(input.value, 10) + (inc ? 1 : -1));
  input.dispatchEvent(new Event('input', { bubbles: true })); // let the colour picker rescale its max
});
